import React from 'react'
import AnimationPage from "../../pages/AnimationPage"

const VODvoucher = () => {
  return (
   <AnimationPage>
     <div >
        <h1>VODvoucher</h1>
    </div>
   </AnimationPage>
  )
}

export default VODvoucher